// extracted by mini-css-extract-plugin
export default {"advertDetailParameterList":"c-q_gg","advertDetailParameterList__header":"c-q_gh","advertDetailParameterList__list":"c-q_gi"};